import {convertFromRaw} from 'draft-js';
import isNumber from 'lodash/isNumber';

export const getLetterFromNumber = number => {
  if (!isNumber(number)) {
    return;
  }
  const result = 'abcdefghijklmnopqrstuvwxyz'.charAt(number);
  return result === '' ? undefined : result;
};

export const containsCaseInsensitive = (a = '', b = '') => {
  return a.trim().toLowerCase().indexOf(b.trim().toLowerCase()) !== -1;
};

export const richTextHasValue = value =>
  value !== undefined && value !== null && value !== '' && value.trim() !== '' && value.trim() !== '<p></p>';

export const draftFieldHasValue = field => {
  const fieldValue = field.value && JSON.parse(field.value);
  const contentState = fieldValue && convertFromRaw(fieldValue);
  const hasText = contentState && contentState.hasText();
  return hasText;
};

export const hexWithoutHash = string => string.replace('#', '');
